import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ZoomGallery from '../components/ZoomGallery';
import DressCTA from './DressCTA';
import { sortedDressImages } from '../data/categoryImageUrl';
import { GOLD_LT, CREAM } from '../theme';

export default function QuickView({ dress, categorySlug, imageUrl, onClose }) {
  const images = sortedDressImages(dress);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    const raf = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(raf);
  }, [dress.slug]);

  return (
    <div
      style={{
        position: 'relative',
        marginTop: 40,
        padding: 'clamp(24px,4vw,40px)',
        background: 'rgba(243,234,214,.03)',
        border: '1px solid rgba(201,162,75,.25)',
        transformOrigin: 'top',
        transform: visible ? 'scaleY(1)' : 'scaleY(0.05)',
        opacity: visible ? 1 : 0,
        transition: 'transform .4s cubic-bezier(.22,1,.36,1), opacity .25s ease',
      }}
    >
      <button
        onClick={onClose}
        aria-label="Close quick view"
        style={{ position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', color: CREAM, fontSize: 24, lineHeight: 1, cursor: 'pointer' }}
      >
        ×
      </button>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'clamp(28px,4vw,48px)' }}>
        <div style={{ flex: '1 1 340px', minWidth: 0, maxWidth: 440 }}>
          <ZoomGallery images={images} imageUrl={imageUrl} altBase={dress.name} />
        </div>
        <div style={{ flex: '1 1 260px', minWidth: 0, paddingTop: 4 }}>
          <h2 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(28px,3.2vw,36px)', margin: '0 0 20px', color: CREAM }}>{dress.name}</h2>
          <DressCTA dress={dress} categorySlug={categorySlug} />
          <Link to={`/categories/${categorySlug}/${dress.slug}`} style={{ display: 'inline-block', marginTop: 24, fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', color: GOLD_LT, textDecoration: 'none' }}>
            More details →
          </Link>
        </div>
      </div>
    </div>
  );
}
